import {
  getTransactionList,
  SuccessResponse,
  TransactionsListResponse,
} from '@back-office/http';
import { cast } from 'mobx-state-tree';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* transactionListRequest(
  self: Self,
  query: string
): Generator<Promise<FlowReturn<TransactionsListResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getTransactionList(query);
    const { data, pagination, status } = (response as TransactionsListResponse)
      .data;
    if (status.code === 1000) {
      self.transaction.reset();
      self.transaction.list = cast(data);
      self.transaction.pagination = pagination;
      return Promise.resolve(ResponseMessage.OK);
    }
    if (status.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default transactionListRequest;
